import { render, staticRenderFns } from "./BookingCancelFees.vue?vue&type=template&id=02bfbdbe&scoped=true"
import script from "./BookingCancelFees.vue?vue&type=script&lang=js"
export * from "./BookingCancelFees.vue?vue&type=script&lang=js"
import style0 from "./BookingCancelFees.vue?vue&type=style&index=0&id=02bfbdbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02bfbdbe",
  null
  
)

export default component.exports